import fillSum from './fill_sum'

export default function fillSumPlus(content = 'asda{Ⓐ}', expression = '|Ⓐ/B=C,Ⓐ=-4;B=3;C=#|', defaultKeys = null) {
  // //console.clear()
  console.log('content')
  console.log(content)
  console.log(expression)
  console.log(JSON.parse(JSON.stringify(defaultKeys)))
  // 取出变量映射数据
  let {keys, empty, pattern} = fillSum(expression, defaultKeys),
  newCte = content
  console.log(keys)
  console.log(content)

  for(let key in keys) {
    let val = keys[key]
    if(newCte.indexOf(`{${key}}`) > -1) {
      if(typeof val === 'object') {
        newCte = newCte.replaceAll(`{${key}}`, val.value)
      } else {
        newCte = newCte.replaceAll(`{${key}}`, val)
      }
    }
  }
  console.log({newCte, empty, pattern, keys })
  return {newCte, empty, pattern, keys }
}